function findCommentsFrameDocument() {
    const iframe = document.querySelector('iframe[title="comments-frame"], #ghost-comments-root iframe, iframe[data-testid="comments-frame"]');
    if (!iframe) return null;
    try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document || null;
        return doc && doc.readyState !== 'uninitialized' ? doc : null;
    } catch (_) {
        return null;
    }
}

function injectStylesIntoCommentsFrame() {
    const doc = findCommentsFrameDocument();
    if (!doc) return false;
    if (doc.getElementById('theme-comments-style')) return true;

    // Ensure IBM Plex Sans is available inside the iframe using local CSS
    try {
        if (!doc.getElementById('theme-comments-font')) {
            const link = doc.createElement('link');
            link.id = 'theme-comments-font';
            link.rel = 'stylesheet';
            link.href = (document.querySelector('link[href*="/built/index.css"]')?.href || '').replace('/built/index.css', '/css/fonts.css')
                || (window.__GHOST_ASSET_BASE__ ? window.__GHOST_ASSET_BASE__ + 'assets/css/fonts.css' : '/assets/css/fonts.css');
            (doc.head || doc.body || doc.documentElement).appendChild(link);
        }
    } catch (_) {}

    const docStyles = getComputedStyle(document.documentElement);
    const colorText = docStyles.getPropertyValue('--color-text')?.trim() || '#f5f5f5';
    const colorTextSecondary = docStyles.getPropertyValue('--color-text-secondary')?.trim() || '#d1d5db';
    const colorTextMuted = docStyles.getPropertyValue('--color-text-muted')?.trim() || '#9ca3af';
    const colorBorder = docStyles.getPropertyValue('--color-border')?.trim() || '#2a2a2a';
    const colorPrimary = docStyles.getPropertyValue('--color-primary')?.trim() || '#1e40af';
    const colorBg = docStyles.getPropertyValue('--color-bg')?.trim() || '#0a0a0a';
    const colorBgSecondary = docStyles.getPropertyValue('--color-bg-secondary')?.trim() || '#1a1a1a';

    const style = doc.createElement('style');
    style.id = 'theme-comments-style';
    style.textContent = `
      :root { --brandcolor: ${colorPrimary}; --ghost-accent-color: ${colorPrimary}; }
      html, body { background: transparent !important; color: ${colorText} !important; }
      html, body, * { font-family: var(--font-sans-serif, "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif) !important; }
      /* Containers */
      .gh-comments, .gh-comments-container, .gh-comments-main, .gh-comments-list { background: ${colorBgSecondary} !important; color: ${colorText} !important; }
      /* Cards */
      .gh-comment, .gh-comment-card, .gh-comments-item, .gh-comment-reply, .gh-comments-login { background: ${colorBg} !important; color: ${colorText} !important; border: 1px solid ${colorBorder} !important; border-radius: 0 !important; box-shadow: none !important; }
      /* Text */
      .gh-comment-content, .gh-comment-text, .gh-comments-empty, .gh-comments-info { color: ${colorTextSecondary} !important; }
      .gh-comment-meta, .gh-comment-date, .gh-comments-hint, .gh-comments-legal { color: ${colorTextMuted} !important; }
      /* Inputs */
      input, textarea { background: ${colorBg} !important; color: ${colorText} !important; border: 1px solid ${colorBorder} !important; border-radius: 0 !important; box-shadow: none !important; }
      input::placeholder, textarea::placeholder { color: ${colorTextMuted} !important; }
      /* Buttons */
      .gh-btn, button, .gh-btn-primary, .gh-btn-secondary, .gh-btn-icon { background: transparent !important; color: ${colorText} !important; border: 1px solid ${colorBorder} !important; border-radius: 0 !important; text-transform: uppercase !important; letter-spacing: 0.06em !important; box-shadow: none !important; }
      .gh-btn-primary, .gh-btn--primary { color: ${colorPrimary} !important; border-color: ${colorPrimary} !important; }
      .gh-btn:hover, .gh-btn-primary:hover, .gh-btn-secondary:hover { color: ${colorPrimary} !important; border-color: ${colorPrimary} !important; background: rgba(0,0,0,0.4) !important; }
      /* Links */
      a { color: ${colorPrimary} !important; }
      a:hover { opacity: 0.9 !important; }
      /* Avatars & separators */
      .gh-comment-avatar, .gh-avatar { box-shadow: none !important; outline: 0 !important; }
      hr, .gh-separator { border-color: ${colorBorder} !important; }
    `;
    (doc.head || doc.body || doc).appendChild(style);
    return true;
}

function setupCommentsStyling() {
    let applied = injectStylesIntoCommentsFrame();
    const observer = new MutationObserver(() => {
        if (!applied) applied = injectStylesIntoCommentsFrame();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    // Retry a few times while the iframe bootstraps
    let attempts = 0;
    const interval = setInterval(() => {
        if (injectStylesIntoCommentsFrame() || attempts++ > 40) clearInterval(interval);
    }, 250);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCommentsStyling);
} else {
    setupCommentsStyling();
}


